<template>
  <div>
    <el-upload ref="upload" v-if="!disabled && (!limit || fileList.length < limit)" :headers="headers" :action="action" :multiple="false"
      :file-list="fileList" :before-upload="beforeUpload" :on-success="successUpload" :show-file-list="false"
      :on-progress="progressUpload" :on-error="errorUpload" :limit="limit" v-bind="$attrs">
      <slot v-bind:fileList="fileList">
        <el-button size="small" type="primary">{{btnText}}</el-button>
      </slot>
      <slot name="tip"></slot>
    </el-upload>

    <transition-group name="fade" tag="div" class="transition_container" v-if="showFileList">
        <slot name="fileList" v-bind:fileList="fileList" v-if="showType === 'list'">
            <template v-for="(item, index) in fileList">
              <video
                :key="item.name"
                v-if="['mp4'].includes(Filter.formatFileTypeSuffix(item.accessUrl))"
                @loadedmetadata="e => handleLoadVideo(e, item)"
                :src="item.accessUrl"
                preload
                width="100%"
                height="100px"
                style="margin: 10px 0"
                controls
              ></video>
              <div class="file_box" :key="item.name" v-else>
                <template v-if="['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(Filter.formatFileTypeSuffix(item.accessUrl))">
                    <el-image ref="elImage" style="width: 70px; height: 70px;cursor: pointer;" :src="item.url"
                        :preview-src-list="previewSrcList">
                    </el-image>
                </template>
                <template v-else>
                    <div style="display: flex;align-items:center;justify-content: center">
                        <img :src="item.url" @click="handlePreview(item)" style="width: 62px; height: 70px;cursor: pointer;">
                    </div>
                </template>
                <div class="file_name" @click="handlePreview(item)">
                {{ item.name }}
                <el-progress :format="(percentage) => (Math.floor(percentage) + '%')" :stroke-width="2"
                    :percentage="item.percentage" v-if="item.percentage && item.percentage < 100"></el-progress>
                </div>
                <div class="success_status" v-if="item.status == 'success' && !disabled">
                    <!-- <i class="el-icon-check"></i> -->
                    <i class="el-icon-close" @click="handleRemove(item, index)"></i>
                </div>
                <!-- <el-button @click="downloadFile(item)" size="mini" type="primary"
                style="position: absolute;right: 5px;bottom: 5px" icon="el-icon-download" circle
                v-if="disabled"></el-button> -->
              </div>
            </template>
        </slot>
        <template v-else-if="showType === 'picture'">
            <div class="picture_box flex-center-center" v-for="(item, index) in fileList" :key="item.name">
              <template v-if="['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(Filter.formatFileTypeSuffix(item.accessUrl))">
                <el-image ref="elImage" :src="item.url" :preview-src-list="previewSrcList" v-if="item.url"></el-image>
                <el-avatar shape="square" :size="100" v-else>上传中</el-avatar>
                <div class="picture_box_action flex-center-center" v-if="item.status == 'success' && !disabled">
                    <i class="el-icon-zoom-in icon" @click="handlePreview(item)"></i>
                    <i class="el-icon-delete icon" @click="handleRemove(item, index)"></i>
                </div>
              </template>
              <template v-else>
                  <div style="display: flex;align-items:center;justify-content: center">
                      <img :src="item.url" @click="handlePreview(item)" style="width: 62px; height: 70px;cursor: pointer;">
                  </div>
              </template>
            </div>
        </template>
        <template v-else>
            <div class="text_box flex-center" v-for="(item, index) in fileList" :key="item.name">
                <el-link type="primary" @click="handleShowOnlinePreview(item)">{{ item.name }}</el-link>
                <span class="percentage" v-if="item.percentage && item.percentage < 100">{{ Math.floor(item.percentage) }}%</span>
                <i class="el-icon-close icon" v-if="item.percentage === 100 && item.status == 'success' && !disabled" @click="handleRemove(item, index)"></i>
            </div>
        </template>
    </transition-group>
    <OnlinePreview v-model="onlinePreview" :src="onlinePreviewSrc" :name="onlinePreviewName" :suffix="onlinePreviewSuffix"
      @onlinePreviewEvent="onlinePreviewSrc = null, onlinePreviewName = null"></OnlinePreview>
  </div>
</template>

<script>
import Filter from '@/utils/formatter';
import docImg from '@/assets/images/doc.png'
import pptImg from '@/assets/images/ppt.png'
import xlsImg from '@/assets/images/xls.png'
import txtImg from '@/assets/images/txt.png'
import pdfImg from '@/assets/images/pdf.png'
import otherImg from '@/assets/images/other.png'
import OnlinePreview from '@/components/OnlinePreview/index'
import { getToken } from "@/utils/auth";
export default {
    name: 'UploadFile',
  props: {
    value: {  //默认上传列表
      type: [Array, String],
      default: () => { return [] }
    },
    disabled: {
      type: Boolean,
      default: false,  // false 显示上传按钮  true 隐藏上传按钮
    },
    btnText: {
        type: String,
        default: '上传文件'
    },
    showType: {  // 显示方式 => picture暂只支持图片
        type: String,
        default: 'list',  // list / picture  / text
    },
    maxSize: { // 文件大小限制
      type: Number,
      default: 10
    },
    limit: Number, // 限制上传文件数量
    imgWidth: Number, // 限制图片宽度
    imgHeight: Number, // 限制图片高度
    showFileList: { // 是否显示文件列表
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      Filter,
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      action: process.env.VUE_APP_FILE_UPLOAD_URL, // 上传的图片服务器地址

      fileList: [],
      previewSrcList: [],
      onlinePreview: false,
      onlinePreviewSrc: null,
      onlinePreviewName: null,
      onlinePreviewSuffix: null
    }
  },
  components: {
    OnlinePreview
  },
  watch: {
    value: {
      handler (newArr) {
        if(!newArr || !newArr.length) {
            this.fileList = [];
        }
        if (typeof newArr == 'string' && newArr.includes('[' && ']')) {
          newArr = JSON.parse(newArr);
          this.$emit('input', newArr)
        }

        this.previewSrcList = [];
        if (newArr && this.fileList.length == 0) {
          this.fileList = newArr.map(item => {
            return {
              ...item,
              status: 'success',
              url: (() => {
                const suffixFile = Filter.formatFileTypeSuffix(item.accessUrl);
                if (['doc', 'docx', 'DOC', 'DOCX'].includes(suffixFile)) return docImg;
                else if (['ppt', 'pptx', 'PPT', 'PPTX'].includes(suffixFile)) return pptImg;
                else if (['xls', 'xlsx', 'XLS', 'XLSX'].includes(suffixFile)) return xlsImg;
                else if (['txt', 'text', 'TXT', 'TEXT'].includes(suffixFile)) return txtImg;
                else if (['pdf', 'PDF'].includes(suffixFile)) return pdfImg;
                else if (['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(suffixFile)) {
                  this.previewSrcList.push(item.accessUrl);
                  return item.accessUrl
                }
                else return otherImg;
              })()
            }
          })
        } else if (newArr && this.fileList.length > 0) {
          newArr.map(item => {
            const suffixFile = Filter.formatFileTypeSuffix(item.accessUrl);
            if (['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(suffixFile)) {
              this.previewSrcList.push(item.accessUrl);
            }
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleLoadVideo(e, item) {
      this.$set(item, 'videoDuration', e.srcElement.duration);
      this.$emit('getVideoDuration', item.accessUrl ?? item.response.data.url,e.srcElement.duration);
    },
    clearFileList() {
        this.fileList = [];
    },
    // downloadFile (item) {
    //   if (Filter.formatFileType(Filter.formatFileTypeSuffix(item.name)) || Filter.formatFileTypeSuffix(item.name) == 'PDF' || Filter.formatFileTypeSuffix(item.name) == 'pdf') {
    //     window.open(item.accessUrl)
    //   } else {
    //     downFile(item.accessUrl, item.name)
    //   }
    // },
    validate () {
      if (this.value.length === this.fileList.length) return true;
      else {
        const h = this.$createElement;
        this.$notify({
          title: '操作失败',
          type: 'error',
          duration: 5000,
          message: h('div', { style: 'color: teal' }, '正在上传文件,请等待文件上传完成后再操作！')
        });
        return false
      }
    },
    async handlePreview (item) {
      if (!item.accessUrl) return;
      if (['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(Filter.formatFileTypeSuffix(item.accessUrl))) {
        this.previewSrcList.map((i, index) => {
          if (item.accessUrl == i) {
            this.$refs.elImage[index].clickHandler()
          }
        })
      } else {
        this.handleShowOnlinePreview(item)
      }
    },
    async handleShowOnlinePreview(item) {
        if (['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(Filter.formatFileTypeSuffix(item.accessUrl))) {
            window.open(item.accessUrl);
        }else if (['txt', 'TXT', 'pdf', 'PDF'].includes(Filter.formatFileTypeSuffix(item.accessUrl))) {
            this.onlinePreview = true;
            this.onlinePreviewName = item.name;
			      this.onlinePreviewSuffix = Filter.formatFileTypeSuffix(item.accessUrl)
            this.onlinePreviewSrc = item.accessUrl;
        } else {
          this.onlinePreview = true;
          this.onlinePreviewName = item.name;
          this.onlinePreviewSuffix = Filter.formatFileTypeSuffix(item.accessUrl)
          // this.onlinePreviewSrc = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.accessUrl)
          this.onlinePreviewSrc = item.accessUrl;
        }
    },
    handleRemove (file, index) {
      this.fileList.splice(index, 1);
      this.$emit('input', this.value.filter(item => item.name !== file.name));
    },
    async beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let existFile = this.$refs.upload.uploadFiles.slice(0, this.$refs.upload.uploadFiles.length - 1).find(f => f.name === file.name);
        if (existFile) {
          const h = this.$createElement;
          this.$notify({
            title: '上传失败',
            type: 'error',
            duration: 3000,
            message: h('div', { style: 'color: teal' }, '当前选取文件已存在')
          });
          reject(false);
        }else if (this.maxSize < file.size / 1024 / 1024) {
          const h = this.$createElement;
          this.$notify({
            title: '上传失败',
            type: 'error',
            duration: 3000,
            message: h('div', { style: 'color: teal' }, '上传的附件不能超过' + this.maxSize + 'M')
          });
          reject(false);
        }else if (this.imgWidth && this.imgHeight) {
          const img = new Image();
          img.onload = async () => {
            if(img.width !== this.imgWidth || img.height !== this.imgHeight) {
              const h = this.$createElement;
              this.$notify({
                title: '上传失败',
                type: 'error',
                duration: 3000,
                message: h('div', { style: 'color: teal' }, '上传的图片尺寸须为' + this.imgWidth + '*' + this.imgHeight)
              });
              reject(false);
            }else {
              resolve(true);
            }
          };
          img.src = URL.createObjectURL(file);
        }else {
          resolve(true);
        }
      })
    },
    // 将文件名字符串的后缀从大写替换为小写
    replaceExtensionCase (fileName) {
        var dotIndex = fileName.lastIndexOf('.');
        if (dotIndex !== -1) {
            var extension = fileName.substring(dotIndex + 1);
    if (extension == 'xls') {
        extension = 'xlsx'
    } else if (extension == 'doc') {
        extension = 'docx'
    }
            fileName = fileName.substring(0, dotIndex) + '.' + extension.toLowerCase();
        }
        return fileName;
    },
    progressUpload (e, file) {
      if (file && this.fileList.filter(i => i.uid === file.uid).length == 0) this.fileList.push(file);
    },
    errorUpload (err, file) {
      const h = this.$createElement;
      this.$notify({
        title: '上传失败',
        type: 'error',
        duration: 5000,
        message: h('div', { style: 'color: teal' }, '服务器内部错误，请重试！')
      });
      this.fileList = this.fileList.filter(i => i.uid !== file.uid);
    },
    successUpload (res, file, fileList) {
      this.fileList = fileList.map(item => {
        return {
          ...item,
          name: this.replaceExtensionCase(item.name),
          accessUrl: item.status == 'success' ? (item.accessUrl ?? item.response.data.url ) : null,
          url: (() => {
            if (item.status !== 'success') return null;
            const suffixFile = Filter.formatFileTypeSuffix(item.accessUrl ?? item.response.data.url);
            if (['doc', 'docx', 'DOC', 'DOCX'].includes(suffixFile)) return docImg;
            else if (['ppt', 'pptx', 'PPT', 'PPTX'].includes(suffixFile)) return pptImg;
            else if (['xls', 'xlsx', 'XLS', 'XLSX'].includes(suffixFile)) return xlsImg;
            else if (['txt', 'text', 'TXT', 'TEXT'].includes(suffixFile)) return txtImg;
            else if (['pdf', 'PDF'].includes(suffixFile)) return pdfImg;
            else if (['jpeg', 'jpg', 'png', 'gif', 'bmp', 'JPEG', 'JPG', 'PNG', 'GIF', 'BMP'].includes(suffixFile)) return item.accessUrl ?? item.response.data.url;
            else return otherImg;
          })()
        }
      });
      this.$emit('input', fileList.reduce((pre, cur) => {
        if (cur.status == 'success') {
          pre.push({
            accessUrl: cur.accessUrl ?? cur.response.data.url,
            name: this.replaceExtensionCase(cur.name) ?? this.replaceExtensionCase(cur.response.data.fileName)
          })
        }
        return pre;
      }, []));
    },
  },
}
</script>

<style scoped lang="scss">
.fade-enter-active {
  transform: translateY(0px);
  opacity: 1;
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.transition_container {
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.file_box {
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px;
  height: 92px;
  display: flex;
  align-items: center;
  position: relative;
  width: calc(100% / 3 - 10px);
  min-width: 350px;

  &:nth-last-of-type(1) {
    margin-bottom: 10px;
  }

  .file_name {
    flex: 1;
    text-align: left;
    color: #606266;
    overflow: hidden;
    padding-left: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color .3s;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  .success_status {
    position: absolute;
    right: 0;
    top: 0px;
    text-align: center;
    border-top-right-radius: 5px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     top: -24px;
    //     right: -24px;
    //     width: 0;
    //     height: 0;
    //     border-top: 23px solid transparent;
    //     border-right: 23px solid transparent;
    //     border-bottom: 23px solid #13ce66;
    //     border-left: 23px solid transparent;
    //     box-shadow: 0 1px 1px #ccc;
    //     transform: rotate(45deg);
    // }
    .el-icon-check {
      color: #fff;
      font-size: 14px;
      position: absolute;
      z-index: 999;
      top: 3px;
      right: 1px;
      display: block;
    }

    .el-icon-close {
      font-size: 18px;
      font-weight: bold;
      position: absolute;
      z-index: 999;
      top: 5px;
      right: 5px;
      color: red;
      // display: none;
      cursor: pointer;
      opacity: 1;
    }
  }
}

.picture_box {
    border-radius: 4px;
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: relative;
    margin-right: 10px;
    margin-top: 10px;
    border: 1px solid rgb(192, 204, 218);
    &:last-child {
        margin-right: 0;
    }
    &:hover {
        .picture_box_action {
            display: flex;
        }
    }
    .picture_box_action {
        display: none;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,0.6);
        .icon{
            color: #fff;
            font-size: 18px;
            cursor: pointer;
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.text_box {
    line-height: 26px;
    width: 100%;
    &:first-child {
        margin-top: 5px;
    }
    .percentage {
        margin-left: 8px;
        color: rgb(96, 98, 102);
    }
    .el-icon-close {
        margin-left: 8px;
        cursor: pointer;
        font-size: 16px;
        color: rgb(96, 98, 102);
        &:hover {
            color: #F56C6C;
        }
    }
}
</style>